<fs-map *ngIf="location" zoom="17" (mapInit)="onMapInit($event)"></fs-map>
